<template>
  <a-form layout="vertical" :model="filters">
    <a-form-item label="ФИО">
      <a-input v-model:value="filters.name" placeholder="Фио" />
    </a-form-item>

    <a-form-item label="Почта">
      <a-input v-model:value="filters.email" placeholder="Почта" />
    </a-form-item>

    <a-row justify="end" :gutter="8">
      <a-col>
        <a-button class="secondary-button" @click="closeForm">
          Отменить
        </a-button>
      </a-col>

      <a-col>
        <a-button class="primary-button" @click="updateFilters">
          Применить
        </a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { computed, reactive, ref, toRaw, watch } from 'vue'
import { useStore } from 'vuex'

export default {
  props: {
    currentGroupId: [Number, String],
  },

  emits: ['close'],

  setup(props, context) {
    const currentFiltersLine = ref('')
    const store = useStore()

    const storedFilters = computed(() => store.state.users.filters)

    const makeLocalFilters = (source = {}) => ({
      name: source.name ?? '',
      job_title: source.job_title ?? '',
      department: source.department ?? '',
      online_from: source.online_from ?? '',
      created_at: source.created_at ?? '',
      email: source.email ?? '',
      telephone: source.telephone ?? '',
      groups: [...(source.groups ?? [])],
      current_group: source.current_group ?? null,
      without_group_only: source.without_group_only ?? false,
      without_limits_only: source.without_limits_only ?? false,
      level_from: source.level_from ?? null,
      level_to: source.level_to ?? null,
    })

    const filters = reactive(makeLocalFilters(storedFilters.value))

    const filterStringLabels = {
      name: 'ФИО',
      job_title: 'Должность',
      department: 'Подразделение',
      online_from: 'Дата входа',
      created_at: 'Дата создания',
      email: 'Почта',
      telephone: 'Телефон',
      without_group_only: 'Без группы',
    }

    const buildInputLineString = () => {
      const parts = []

      Object.entries(filterStringLabels).forEach(([key, label]) => {
        if (!filters[key]) {
          return
        }

        parts.push(`${label}: ${filters[key]}`)
      })

      currentFiltersLine.value = parts.join(', ')
    }

    const updateFilters = () => {
      buildInputLineString()

      store.dispatch('users/setUserFilters', {
        filters: {
          ...toRaw(filters),
          groups: [...(filters.groups ?? [])],
        },
        filterString: currentFiltersLine.value,
      })

      closeForm()
    }

    const closeForm = () => {
      context.emit('close')
    }

    watch(storedFilters, () => {
      Object.assign(filters, makeLocalFilters(storedFilters.value))
    })

    return {
      filters,
      updateFilters,
      closeForm,
    }
  },
}
</script>

<style scoped lang="scss">
:deep(.ant-form-item-label) {
  padding-bottom: 4px !important;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}
</style>